import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";

const STORAGE_KEY = "hh_newsletter";
const RESHOW_AFTER_DAYS = 3;

const ModalContext = createContext();
export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const timerRef = useRef(null);

  const shouldShow = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return true; // pehli baar

      const { status, timestamp } = JSON.parse(stored);

      // Subscribed — kabhi mat dikhao
      if (status === "subscribed") return false;

      // Closed — 3 din baad dikhao
      if (status === "closed") {
        const daysSinceClosed =
          (Date.now() - timestamp) / (1000 * 60 * 60 * 24);
        return daysSinceClosed >= RESHOW_AFTER_DAYS;
      }

      return true;
    } catch {
      return true;
    }
  };

  useEffect(() => {
    if (!shouldShow()) return;

    timerRef.current = setTimeout(() => {
      setShowModal(true);
    }, 4000);

    return () => clearTimeout(timerRef.current);
  }, []);

  useEffect(() => {
    if (!shouldShow()) return;

    timerRef.current = setTimeout(() => {
      setShowModal(true);
    }, 50000);

    return () => clearTimeout(timerRef.current);
  }, []);

  // ── User ne close kiya without subscribing ──────────────
  const handleClose = () => {
    setShowModal(false);
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ status: "closed", timestamp: Date.now() }),
    );
  };

  // ── User ne subscribe kiya ───────────────────────────────
  const handleSubscribed = () => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ status: "subscribed", timestamp: Date.now() }),
    );
  };

  return (
    <ModalContext.Provider value={{ showModal, handleClose, handleSubscribed }}>
      {children}
    </ModalContext.Provider>
  );
};
